import styled from "styled-components";

export const ClickableTableRow = styled.tr<{}>(({ onClick }) => ({
  ...(onClick
    ? {
        userSelect: 'none',
        tabIndex: 0,
        role: 'button',
        outline: 'none',
        cursor: 'pointer',
      }
    : {}),
}));
